import './Title.css'
export default function Title(props) {
  return (
    <div className={`title-${props.center ? "center" : "start"}`}>
      <h2>{props.name}</h2>
    </div>
  );
}
